import { BrowserRouter, Route, Routes } from "react-router-dom";

import PageLogin from "./pages/Login";
import PageLandingPage from "./pages/LandingPage";
import ColaboradoresPage from "./pages/GestionPage/ColaboradoresPage";
import FormatoEvaluacionPage from "./pages/GestionPage/FormatoEvaluacionPage";
import SeleccionarPanel from "./pages/SeleccionarPanel";
import AdministracionUsuariosExternosPage from "./pages/AdministracionUsuariosExternosPage/ColaboradoresPage";
import AdministracionParametrosPage from "./pages/AdministracionUsuariosExternosPage/ParametrosPage";
import RealizarEvaluacionesPage from "./pages/Evaluaciones/RealizarEvaluacionesPage";
import ReporteEvaluacionesPage from "./pages/ReporteEvaluacionesPage";
import FormatoEvaluacionesPage from "./pages/FormatoEvaluacionPage";
import CategoriasEvaluacionesPage from "./pages/GestionPage/CategoriasEvaluacionesPage";
import RoleRoute from "./RoleRoute";

import { Provider } from "react-redux";
import Store from "./pages/redux/store/Store";
import "./App.css";

function App() {
  return (
    <Provider store={Store}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PageLogin />} />
          <Route path="/seleccionarPanel" element={<SeleccionarPanel />} />
          <Route path="/home" element={<PageLandingPage />} />
          <Route path="/gestionColaboradores"
            element={<RoleRoute allowedProfiles={["Administrador", "Evaluador"]}><ColaboradoresPage /></RoleRoute>}
          />
          <Route path="/gestionCategoriasEvaluaciones"
            element={<RoleRoute allowedProfiles={["Administrador"]}><CategoriasEvaluacionesPage /></RoleRoute>}
          />
          <Route path="/gestionFormatoEvaluacion"
            element={<RoleRoute allowedProfiles={["Administrador"]}><FormatoEvaluacionPage /></RoleRoute>}
          />
          <Route path="/realizarEvaluaciones"
            element={<RoleRoute allowedProfiles={["Evaluador", "Evaluador Externo"]}><RealizarEvaluacionesPage /></RoleRoute>}
          />
          <Route path="/admonUsuariosExternos"
            element={<RoleRoute allowedProfiles={["Administrador"]}><AdministracionUsuariosExternosPage /></RoleRoute>}
          />
          <Route path="/admonUsuariosParametros"
            element={<RoleRoute allowedProfiles={["Administrador"]}><AdministracionParametrosPage /></RoleRoute>}
          />
          <Route path="/reporteEvaluaciones"
            element={<RoleRoute allowedProfiles={["Administrador", "Evaluador", "Evaluador Externo"]}><ReporteEvaluacionesPage /></RoleRoute>}
          />
          <Route path="/formatoEvaluaciones/:id/:date"
            element={<RoleRoute allowedProfiles={["Administrador", "Evaluador", "Evaluador Externo"]}><FormatoEvaluacionesPage /></RoleRoute>}
          />
        </Routes>
      </BrowserRouter>
    </Provider>
  );
}

export default App;